'use strict';

import React, { PureComponent } from 'react';
import Image from 'Pure/Image';
import GLOBAL_CONFIG from 'Shared/config';
const types = {
  default: GLOBAL_CONFIG.logo,
  white: GLOBAL_CONFIG.logo_white,
  dark: GLOBAL_CONFIG.logo,
  full: GLOBAL_CONFIG.logo_full
};
export default class Logo extends PureComponent {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/React.createElement(Image, {
      src: types[props.type || 'default'],
      alt: 'Logo ' + GLOBAL_CONFIG.front_name,
      title: GLOBAL_CONFIG.front_name,
      style: {
        ...props.style
      },
      className: props.className
    });
    return output;
  }
}
